import { useContext,useState } from 'react';
import { useNavigate } from 'react-router-dom';

import ArtlistDataContext from '@/context/ArtlistDataContext';
import useTranslations from '@/i18n/useTranslations';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import Popup from '@/shared-components/popups/components/Popup';
import Utils from '@/utils';

import PersonalizedTime from './components/PersonalizedTime';
import TimeOption from './components/TimeOption';

import './index.css';

const TIME_PRESETS = [
  { key: 'fifteen_seconds', quantity: '15', unit: 'seconds' },
  { key: 'one_minute', quantity: '1', unit: 'minutes' },
  { key: 'five_minutes', quantity: '5', unit: 'minutes' },
  { key: 'one_hour', quantity: '1', unit: 'hours' },
];

export default function TimeSelector({ open, close }) {
  const { artlistData } = useContext(ArtlistDataContext);
  const t = useTranslations('common.profile.pages.artlist');
  const [formState, setFormState] = useState({
    time_quantity: "",
    time_unit: "seconds",
    time_selected: "personalized"
  });
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  function updateFormState(quantity, unit, selected) {
    setFormState({
      time_quantity: quantity,
      time_unit: unit,
      time_selected: selected
    });

    setError(null);
  }

  function onPlayArtlist() {
    const parsedValue = Number(formState.time_quantity);

    if (!Number.isInteger(parsedValue) || parsedValue < 1) {
      setError({ element: "time_quantity", error_code: "INVALID_ARTLIST_PERSONALIZED_TIME" });
    } else {
      navigate("/artlist/play", {
        state: {
          slideDuration: Utils.getMSFromTimeUnit([formState.time_quantity, formState.time_unit]), 
          artlistArtworks: artlistData.artlist_artworks
        }
      });
    }
  }

  return (
    <>
      <Popup 
        open={open} 
        close={close} 
        className="time-selector-popup" 
        title={t('time_selector.title')} 
        opacity
      >
        {TIME_PRESETS.map(({ key, quantity, unit }) => (
          <TimeOption
            key={key}
            text={t(`time_selector.options.${key}`)}
            isSelected={formState.time_selected === key}
            selectOption={() => updateFormState(quantity, unit, key)}
          />
        ))}

        <TimeOption
          text={t('time_selector.options.personalized')}
          isSelected={formState.time_selected === "personalized"}
          selectOption={() => updateFormState("", "seconds", "personalized")}
        />

        <PersonalizedTime 
          formState={formState} 
          setFormState={setFormState}
          error={error}
        />

        <ContinueButton 
          className="time-selector__button"
          onClick={onPlayArtlist}
          turnOff={
            !formState.time_quantity || 
                        !formState.time_unit
          }
        >
          {t('time_selector.actions.play_artlist')}
        </ContinueButton>
      </Popup>
    </>
  );
}
